import React, { useCallback } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import FacebookIcon from '@mui/icons-material/FacebookRounded';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { useNavigate } from 'react-router-dom';

import DownloadApple from '../../assets/download-apple.png';
import DownloadGoogle from '../../assets/download-google.png';
import FooterBg from '../../assets/footer-bg.png';
import FooterImage from '../../assets/Group76.png';
import {
  FOOTER_PRODUCT_LINKS,
  KNOW_US_LINKS,
  SOCIAL_LINKS,
} from '../config/footerLinks';
import { useV2Common } from '../state/CommonProvider';

const styles = {
  root: {
    color: '#000',
    display: 'flex',
    padding: '2vw',
    textAlign: 'center',
    flexDirection: 'column',
    background: `url(${FooterBg})`,
    backgroundSize: 'cover',
    paddingTop: '80px',
    paddingBottom: 0,
    minHeight: 550,
    width: '100%',
    boxSizing: 'border-box',
  },
  contentCont: {
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    display: 'flex',
    position: 'relative',
  },
  footerImageCont: {
    position: 'relative',
    margin: '10px',
    width: '30%',
  },
  storeIcon: {
    width: '100px',
    height: '30px',
    borderRadius: '10px',
    cursor: 'pointer',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    margin: '10px',
    background: '#FFF0D9',
    borderRadius: '5px',
    padding: '2px 0',
  },
  icon: {
    fontSize: '1.2rem',
    cursor: 'pointer',
    background: '#a4243d',
    color: '#FFF0D9',
    borderRadius: '45%',
    border: '2px solid #a4243d',
  },
  textSection: {
    color: '#FFF0D9',
    textAlign: 'center',
    textDecoration: 'underline',
    fontFamily: 'Foregen',
  },
};

const linkSx = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '10px',
  cursor: 'pointer',
  fontSize: '15px',
  fontWeight: 400,
  fontFamily: 'Roboto',
  '&:hover': { opacity: 0.85 },
};

export default function V2Footer() {
  const navigate = useNavigate();
  const { isDesktop } = useV2Common();

  const openUrl = useCallback((url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  }, []);

  if (!isDesktop) return null;

  return (
    <Box component="footer" style={styles.root}>
      <Grid
        container
        spacing={2}
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          maxWidth: 1280,
          mx: 'auto',
        }}
      >
        <Grid sm={4} md={6} lg={6}>
          <div style={styles.contentCont}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Box
                sx={{
                  fontSize: '1rem',
                  fontWeight: 400,
                  marginBottom: '10px',
                  textAlign: 'start',
                  marginLeft: '6vw',
                  textDecoration: 'underline',
                  fontFamily: 'Foregen',
                }}
              >
                Our Products
              </Box>
              <Box sx={{ marginLeft: '6vw' }}>
                {FOOTER_PRODUCT_LINKS.map((item) => (
                  <Box
                    key={item.path}
                    sx={linkSx}
                    onClick={() => navigate(item.path)}
                    role="link"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigate(item.path);
                      }
                    }}
                  >
                    {item.label}
                  </Box>
                ))}
              </Box>
            </Box>
          </div>
        </Grid>

        <Grid sm={4} md={6} lg={6}>
          <div style={styles.contentCont}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Box
                sx={{
                  fontSize: '1rem',
                  fontWeight: 400,
                  marginBottom: '10px',
                  lineHeight: '22.7px',
                  textAlign: 'start',
                  marginLeft: '4vw',
                  fontFamily: 'Foregen',
                  textDecoration: 'underline',
                }}
              >
                Know Us
              </Box>
              <Box sx={{ marginLeft: '4vw' }}>
                {KNOW_US_LINKS.map((item) => (
                  <Box
                    key={item.path}
                    sx={linkSx}
                    onClick={() => navigate(item.path)}
                    role="link"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigate(item.path);
                      }
                    }}
                  >
                    {item.label}
                  </Box>
                ))}
              </Box>
            </Box>
          </div>
        </Grid>

        <Grid xs={6} sm={6} md={6}>
          <Box sx={styles.textSection}>
            <Box sx={{ fontSize: '1rem', fontWeight: 400, marginBottom: '10px' }}>
              Download Our App
            </Box>
            <Box sx={{ display: 'flex', marginLeft: '6vw', justifyContent: 'center' }}>
              <img src={DownloadGoogle} alt="Download on Google Play" style={styles.storeIcon} />
              <img src={DownloadApple} alt="Download on Apple Store" style={styles.storeIcon} />
            </Box>
          </Box>
        </Grid>

        <Grid xs={5} sm={6} md={2}>
          <Box sx={styles.textSection}>
            <Box sx={{ fontSize: '1rem', fontWeight: 400, marginBottom: '10px' }}>
              Connect with Us
            </Box>
            <Box sx={styles.iconContainer}>
              <FacebookIcon
                style={styles.icon}
                onClick={() => openUrl(SOCIAL_LINKS[0].url)}
                aria-label={SOCIAL_LINKS[0].label}
              />
              <InstagramIcon
                style={styles.icon}
                onClick={() => openUrl(SOCIAL_LINKS[1].url)}
                aria-label={SOCIAL_LINKS[1].label}
              />
              <WhatsAppIcon
                style={styles.icon}
                onClick={() => openUrl(SOCIAL_LINKS[2].url)}
                aria-label={SOCIAL_LINKS[2].label}
              />
              <LinkedInIcon
                style={styles.icon}
                onClick={() => openUrl(SOCIAL_LINKS[3].url)}
                aria-label={SOCIAL_LINKS[3].label}
              />
            </Box>
          </Box>
        </Grid>

        <Grid xs={1} sm={1} md={1} />

        <Grid sx={{ width: '100%' }}>
          <Box>
            <img src={FooterImage} alt="" style={styles.footerImageCont} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
